<template>
  <component
    :is="name"
    v-if="doesIconExist"
    class="obj_icon"
    :class="{
      'obj_icon--big-on-mobile': isBigOnMobile,
      'obj_icon--2xs': size === '2xs',
      'obj_icon--xs': size === 'xs',
      'obj_icon--sm': size === 'sm',
      'obj_icon--md': size === 'md',
      'obj_icon--ml': size === 'ml',
      'obj_icon--lg': size === 'lg',
      'obj_icon--xl': size === 'xl',
      'obj_icon--2xl': size === '2xl',
      'obj_icon--3xl': size === '3xl',
      'obj_icon--4xl': size === '4xl',
    }"
  />
</template>

<script>
import activity from '@/assets/icons/pf-icon-activity.svg?component'
import adopt from '@/assets/icons/pf-icon-adopt.svg?component'
import approval from '@/assets/icons/pf-icon-approval.svg?component'
import arrowDown from '@/assets/icons/pf-icon-arrow-down.svg?component'
import arrowLeft from '@/assets/icons/pf-icon-arrow-left.svg?component'
import arrowLongLeft from '@/assets/icons/pf-icon-arrow-long-left.svg?component'
import arrowLongRight from '@/assets/icons/pf-icon-arrow-long-right.svg?component'
import arrowRight from '@/assets/icons/pf-icon-arrow-right.svg?component'
import arrowUpRight from '@/assets/icons/pf-icon-arrow-up-right.svg?component'
import arrowUp from '@/assets/icons/pf-icon-arrow-up.svg?component'
import attachment from '@/assets/icons/pf-icon-attachment.svg?component'
import attention from '@/assets/icons/pf-icon-attention.svg?component'
import backup from '@/assets/icons/pf-icon-backup.svg?component'
import bug from '@/assets/icons/pf-icon-bug.svg?component'
import calendar from '@/assets/icons/pf-icon-calendar.svg?component'
import cameraIcon from '@/assets/icons/pf-icon-camera.svg?component'
import category from '@/assets/icons/pf-icon-category.svg?component'
import checkmarkCircle from '@/assets/icons/pf-icon-checkmark-circle.svg?component'
import checkmark from '@/assets/icons/pf-icon-checkmark.svg?component'
import chevronDown from '@/assets/icons/pf-icon-chevron-down.svg?component'
import chevronLeft from '@/assets/icons/pf-icon-chevron-left.svg?component'
import chevronRight from '@/assets/icons/pf-icon-chevron-right.svg?component'
import chevronUp from '@/assets/icons/pf-icon-chevron-up.svg?component'
import circleIcon from '@/assets/icons/pf-icon-circle.svg?component'
import clipboard from '@/assets/icons/pf-icon-clipboard.svg?component'
import closeCircle from '@/assets/icons/pf-icon-close-circle.svg?component'
import comment from '@/assets/icons/pf-icon-comment.svg?component'
import company from '@/assets/icons/pf-icon-company.svg?component'
import copy from '@/assets/icons/pf-icon-copy.svg?component'
import crossmark from '@/assets/icons/pf-icon-crossmark.svg?component'
import dashboard from '@/assets/icons/pf-icon-dashboard.svg?component'
import deleteIcon from '@/assets/icons/pf-icon-delete.svg?component'
import download from '@/assets/icons/pf-icon-download.svg?component'
import draftCircle from '@/assets/icons/pf-icon-draft-circle.svg?component'
import drag from '@/assets/icons/pf-icon-drag.svg?component'
import draw from '@/assets/icons/pf-icon-draw.svg?component'
import duedate from '@/assets/icons/pf-icon-duedate.svg?component'
import edit from '@/assets/icons/pf-icon-edit.svg?component'
import ellipsisHorizontalCircle from '@/assets/icons/pf-icon-ellipsis-horizontal-circle.svg?component'
import ellipsisHorizontal from '@/assets/icons/pf-icon-ellipsis-horizontal.svg?component'
import emailPlus from '@/assets/icons/pf-icon-email-plus.svg?component'
import email from '@/assets/icons/pf-icon-email.svg?component'
import exclamationMark from '@/assets/icons/pf-icon-exclamation-mark.svg?component'
import expand from '@/assets/icons/pf-icon-expand.svg?component'
import exportIcon from '@/assets/icons/pf-icon-export.svg?component'
import faq from '@/assets/icons/pf-icon-faq.svg?component'
import file from '@/assets/icons/pf-icon-file.svg?component'
import filterIcon from '@/assets/icons/pf-icon-filter.svg?component'
import folderClosed from '@/assets/icons/pf-icon-folder-closed.svg?component'
import folderOpen from '@/assets/icons/pf-icon-folder-open.svg?component'
import fullscreen from '@/assets/icons/pf-icon-fullscreen.svg?component'
import hamburger from '@/assets/icons/pf-icon-hamburger.svg?component'
import hashtag from '@/assets/icons/pf-icon-hashtag.svg?component'
import help from '@/assets/icons/pf-icon-help.svg?component'
import home from '@/assets/icons/pf-icon-home.svg?component'
import importIcon from '@/assets/icons/pf-icon-import.svg?component'
import inProcessCircle from '@/assets/icons/pf-icon-in-process-circle.svg?component'
import infoCircle from '@/assets/icons/pf-icon-info-circle.svg?component'
import invisible from '@/assets/icons/pf-icon-invisible.svg?component'
import layers from '@/assets/icons/pf-icon-layers.svg?component'
import layoutColumn from '@/assets/icons/pf-icon-layout-column.svg?component'
import layoutDetail from '@/assets/icons/pf-icon-layout-detail.svg?component'
import layoutMini from '@/assets/icons/pf-icon-layout-mini.svg?component'
import linkIcon from '@/assets/icons/pf-icon-link.svg?component'
import listView from '@/assets/icons/pf-icon-list-view.svg?component'
import locationTag from '@/assets/icons/pf-icon-location-tag.svg?component'
import location from '@/assets/icons/pf-icon-location.svg?component'
import locked from '@/assets/icons/pf-icon-locked.svg?component'
import logout from '@/assets/icons/pf-icon-logout.svg?component'
import markerIcon from '@/assets/icons/pf-icon-marker.svg?component'
import newFeature from '@/assets/icons/pf-icon-new-feature.svg?component'
import nextCircle from '@/assets/icons/pf-icon-next-circle.svg?component'
import notification from '@/assets/icons/pf-icon-notification.svg?component'
import open from '@/assets/icons/pf-icon-open.svg?component'
import overlay from '@/assets/icons/pf-icon-overlay.svg?component'
import owner from '@/assets/icons/pf-icon-owner.svg?component'
import paperPlane from '@/assets/icons/pf-icon-paper-plane.svg?component'
import pause from '@/assets/icons/pf-icon-pause.svg?component'
import personalSupport from '@/assets/icons/pf-icon-personal-support.svg?component'
import phone from '@/assets/icons/pf-icon-phone.svg?component'
import photoSphere from '@/assets/icons/pf-icon-photo-sphere.svg?component'
import photo from '@/assets/icons/pf-icon-photo.svg?component'
import photosPlus from '@/assets/icons/pf-icon-photos-plus.svg?component'
import plan from '@/assets/icons/pf-icon-plan.svg?component'
import play from '@/assets/icons/pf-icon-play.svg?component'
import plus from '@/assets/icons/pf-icon-plus.svg?component'
import prevCircle from '@/assets/icons/pf-icon-prev-circle.svg?component'
import print from '@/assets/icons/pf-icon-print.svg?component'
import projectLang from '@/assets/icons/pf-icon-project-lang.svg?component'
import projectTransfer from '@/assets/icons/pf-icon-projecttransfer.svg?component'
import reorder from '@/assets/icons/pf-icon-reorder.svg?component'
import reset from '@/assets/icons/pf-icon-reset.svg?component'
import restore from '@/assets/icons/pf-icon-restore.svg?component'
import role from '@/assets/icons/pf-icon-role.svg?component'
import screenSupport from '@/assets/icons/pf-icon-screen-support.svg?component'
import searchIcon from '@/assets/icons/pf-icon-search.svg?component'
import settings from '@/assets/icons/pf-icon-settings.svg?component'
import share from '@/assets/icons/pf-icon-share.svg?component'
import shrink from '@/assets/icons/pf-icon-shrink.svg?component'
import sortDown from '@/assets/icons/pf-icon-sort-down.svg?component'
import sortHorizontal from '@/assets/icons/pf-icon-sort-horizontal.svg?component'
import sortUp from '@/assets/icons/pf-icon-sort-up.svg?component'
import sort from '@/assets/icons/pf-icon-sort.svg?component'
import star from '@/assets/icons/pf-icon-star.svg?component'
import stopIcon from '@/assets/icons/pf-icon-stop.svg?component'
import sync from '@/assets/icons/pf-icon-sync.svg?component'
import tag from '@/assets/icons/pf-icon-tag.svg?component'
import tasks from '@/assets/icons/pf-icon-tasks.svg?component'
import templateIcon from '@/assets/icons/pf-icon-template.svg?component'
import textblock from '@/assets/icons/pf-icon-textblock.svg?component'
import tips from '@/assets/icons/pf-icon-tips.svg?component'
import topCategory from '@/assets/icons/pf-icon-top-category.svg?component'
import trash from '@/assets/icons/pf-icon-trash.svg?component'
import twofactor from '@/assets/icons/pf-icon-twofactor.svg?component'
import unlocked from '@/assets/icons/pf-icon-unlocked.svg?component'
import update from '@/assets/icons/pf-icon-update.svg?component'
import upload from '@/assets/icons/pf-icon-upload.svg?component'
import userAccount from '@/assets/icons/pf-icon-user-account.svg?component'
import userAdmin from '@/assets/icons/pf-icon-user-admin.svg?component'
import userParticipant from '@/assets/icons/pf-icon-user-participant.svg?component'
import userReadOnly from '@/assets/icons/pf-icon-user-read-only.svg?component'
import userSilentParticipant from '@/assets/icons/pf-icon-user-silent-participant.svg?component'
import user from '@/assets/icons/pf-icon-user.svg?component'
import visible from '@/assets/icons/pf-icon-visible.svg?component'
import zoomIn from '@/assets/icons/pf-icon-zoom-in.svg?component'
import zoomOut from '@/assets/icons/pf-icon-zoom-out.svg?component'
import activitiesOutline from '@/assets/img/tab-icon-activities-ol.svg?component'
import documentsOutline from '@/assets/img/tab-icon-documents-ol.svg?component'
import notificationsOutline from '@/assets/img/tab-icon-notifications-ol.svg?component'
import participantsOutline from '@/assets/img/tab-icon-participants-ol.svg?component'
import photodocOutline from '@/assets/img/tab-icon-photodoc-ol.svg?component'
import plansOutline from '@/assets/img/tab-icon-plans-ol.svg?component'
import projectOutline from '@/assets/img/tab-icon-project-ol.svg?component'
import sendOutline from '@/assets/img/tab-icon-send-ol.svg?component'
import settingsOutline from '@/assets/img/tab-icon-settings-ol.svg?component'
import tasksOutline from '@/assets/img/tab-icon-tasks-ol.svg?component'

export default {
  name: 'PfIcon',

  components: {
    activity,
    adopt,
    approval,
    attachment,
    attention,
    arrowDown,
    arrowLeft,
    arrowRight,
    arrowUp,
    arrowUpRight,
    arrowLongLeft,
    arrowLongRight,
    backup,
    bug,
    cameraIcon,
    calendar,
    category,
    checkmark,
    checkmarkCircle,
    chevronDown,
    chevronLeft,
    chevronRight,
    chevronUp,
    circleIcon,
    clipboard,
    closeCircle,
    comment,
    company,
    copy,
    crossmark,
    dashboard,
    deleteIcon,
    download,
    draftCircle,
    drag,
    draw,
    duedate,
    edit,
    ellipsisHorizontal,
    ellipsisHorizontalCircle,
    email,
    emailPlus,
    exclamationMark,
    expand,
    exportIcon,
    faq,
    file,
    filterIcon,
    folderClosed,
    folderOpen,
    fullscreen,
    hamburger,
    hashtag,
    help,
    home,
    importIcon,
    inProcessCircle,
    infoCircle,
    invisible,
    layers,
    layoutColumn,
    layoutDetail,
    layoutMini,
    linkIcon,
    listView,
    location,
    locationTag,
    locked,
    logout,
    markerIcon,
    newFeature,
    nextCircle,
    notification,
    open,
    overlay,
    owner,
    paperPlane,
    pause,
    personalSupport,
    phone,
    photo,
    photoSphere,
    photosPlus,
    plan,
    play,
    plus,
    prevCircle,
    print,
    projectLang,
    projectTransfer,
    reorder,
    restore,
    reset,
    role,
    screenSupport,
    searchIcon,
    settings,
    share,
    shrink,
    sort,
    sortDown,
    sortHorizontal,
    sortUp,
    star,
    stopIcon,
    sync,
    tag,
    tasks,
    templateIcon,
    textblock,
    tips,
    topCategory,
    trash,
    twofactor,
    unlocked,
    update,
    upload,
    user,
    userAccount,
    userAdmin,
    userParticipant,
    userSilentParticipant,
    userReadOnly,
    visible,
    activitiesOutline,
    documentsOutline,
    notificationsOutline,
    participantsOutline,
    photodocOutline,
    plansOutline,
    projectOutline,
    sendOutline,
    settingsOutline,
    tasksOutline,
    zoomIn,
    zoomOut,
  },

  props: {
    name: {
      type: String,
      required: true,
    },

    isBigOnMobile: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: '',
    },
  },

  computed: {
    doesIconExist () {
      return this.$options.components[this.name]
    },
  },

  created () {
    if (!this.doesIconExist) {
      throw new Error(`Icon "${this.name}" does not exist (or not defined in the PfIcon component)`)
    }
  },
}
</script>
